import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";
import { GetInventoryPurchase } from "../../../core/models/inventoryPurchases/InventoryPurchaseHeaderLineDto";

@Component({
  selector: "jni-inventory-purchase-summary-listing",
  templateUrl: "./inventory-purchase-summary-listing.component.html",
  styleUrls: ["./inventory-purchase-summary-listing.component.scss"],
  imports: [TableModule, CommonModule, FormsModule, SelectModule],
})
export class InventoryPurchaseSummaryListingComponent {
  @Input() inventoryPurchaseLines!: PurchaseOrderLine[];
  @Input() purchaseOrderHeader!: GetInventoryPurchase | null;
  finishedGoodsList = [
    {
      id: 1,
      itemNumber: "RHNAM-9606",
      description: "Red Hat Baby Onesie-18/24-Blk",
      productName: "Red Hat Baby Onesie",
      configuration: "",
      size: "18/24",
      color: "BLK",
      style: "",
      quantity: "1.00",
      unit: "ea",
    },
    {
      id: 2,
      itemNumber: "RHNAM-9606",
      description: "Red Hat Baby Onesie-18/24-Blk",
      productName: "Red Hat Baby Onesie",
      configuration: "",
      size: "18/24",
      color: "BLK",
      style: "",
      quantity: "1.00",
      unit: "ea",
    },
  ];
  selectedGoods = []; // Array to store selected items

  deleteButtonStatus = false;

  dropdown = ["Apple", "Oranges", "Mango"];

  descriptionCharacterCond = false;

  hideDeleteLineButtons() {
    this.deleteButtonStatus = !this.deleteButtonStatus;
    //this.finishedGoodsList;
  }

  descriptionCharacterCount(obj: string) {
    if (obj && obj?.length > 45) {
      this.descriptionCharacterCond = true;
    }
  }
}
